import { useState, useCallback } from 'react';
import { api } from '@/shared/api/axios';

export function useApi() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const get = useCallback(async (url: string, params?: any) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.get(url, { params });
      return res.data;
    } catch (err: any) {
      const msg = err.response?.data?.error?.message || err.response?.data?.message || err.message || 'API request failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const post = useCallback(async (url: string, data?: any) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.post(url, data);
      return res.data;
    } catch (err: any) {
      const msg = err.response?.data?.error?.message || err.response?.data?.message || err.message || 'API request failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const put = useCallback(async (url: string, data?: any) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.put(url, data);
      return res.data;
    } catch (err: any) {
      const msg = err.response?.data?.error?.message || err.response?.data?.message || err.message || 'API request failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const patch = useCallback(async (url: string, data?: any) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.patch(url, data);
      return res.data;
    } catch (err: any) {
      const msg = err.response?.data?.error?.message || err.response?.data?.message || err.message || 'API request failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  const del = useCallback(async (url: string) => {
    setLoading(true);
    setError(null);
    try {
      const res = await api.delete(url);
      return res.data;
    } catch (err: any) {
      const msg = err.response?.data?.error?.message || err.response?.data?.message || err.message || 'API request failed';
      setError(msg);
      throw new Error(msg);
    } finally {
      setLoading(false);
    }
  }, []);

  return { get, post, put, patch, del, delete: del, loading, error, setError };
}
